import {Container, Col, Row }from 'react-bootstrap';

import Header from '../sections/header';
import Footer from '../sections/footer';
import MainContent from '../sections/maincontent';
import PrivacyPolicyText from '../content/PrivacyPolicy';
function PagePrivacy(){
    return (
        <> 
            <Header />
            <Container fluid className="color-bg-secondary">
                    <MainContent>
                        <Row>
                            <Col md={{span: 4, offset: 4}}>
                                <PrivacyPolicyText />
                            </Col>
                        </Row>     
                    </MainContent>
            </Container>
            <Footer />
        </>
    )
}

export default PagePrivacy;